// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import API from '@/api/index'
import router from './router'
import store from './store'
import Loading from "@/components/loading/loading"
import VueClipboard from 'vue-clipboard2'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import "@/styles/index.scss"
import "@/styles/common.css"

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from "vant"
import 'vant/lib/index.css'

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'


Vue.component("Loading", Loading)
Vue.use(VueClipboard)
Vue.use(Element);
Vue.use(Vant);

const ossQiniu = (url, w = 120, h = 120, modenum = 2,multiple = 3,format="jpg",type = null)=>{

  if(typeof (url) !== 'string'){
    url = url ? url[0] : url;
  }

  let image = '';
  if(!modenum||modenum==null||modenum==''){
    modenum = 2
  }
  if(!multiple||multiple==null||multiple==''){
    multiple = 3
  }
  if(!format||format==null||format==''){
    format = "jpg";
  }
  if(url&&url!=='') {
    var reg = RegExp(/.mp4/);
    if (url.match(reg)) {
      if ((/^(http|https):\/\/.+/.test(url))) {
        return url;
      } else {
        return 'https://sanhaopeisong.com ' + url;
      }
    }
  }
  return image;
}


Vue.prototype.$wanlshop = {
  ossQiniu
}
Vue.prototype.$API = API;
Vue.prototype.IMG_URL = '/static/';
Vue.prototype.API_URL = "http://lp.daifahu.com/";
// Vue.prototype.IMG_URL = '/theme/style2/static/';
// Vue.prototype.API_URL = "";
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js